import React from 'react';
import { MapContainer, TileLayer, Marker, Popup, Circle } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

const ShopLocationsMap = ({ shops }) => {
  if (typeof window === 'undefined') return null;

  // Calculate center point from shops' coordinates
  const getMapCenter = () => {
    if (!shops || shops.length === 0) {
      return [33.7293882, 73.0931461]; // Default coordinates
    }

    const validShops = shops.filter(shop => shop.geometry?.coordinates);
    if (validShops.length === 0) return [33.7293882, 73.0931461];

    const totalLat = validShops.reduce((sum, shop) => sum + shop.geometry.coordinates[1], 0);
    const totalLng = validShops.reduce((sum, shop) => sum + shop.geometry.coordinates[0], 0);
    
    return [
      totalLat / validShops.length,
      totalLng / validShops.length
    ];
  };

  // Calculate appropriate zoom level based on shop distances
  const getInitialZoom = () => {
    if (shops.length <= 1) return 13;
    
    const lats = shops.map(shop => shop.geometry?.coordinates[1] || 0);
    const lngs = shops.map(shop => shop.geometry?.coordinates[0] || 0);
    
    const latDiff = Math.max(...lats) - Math.min(...lats);
    const lngDiff = Math.max(...lngs) - Math.min(...lngs);
    const maxDiff = Math.max(latDiff, lngDiff);
    
    if (maxDiff > 0.5) return 10;
    if (maxDiff > 0.2) return 11;
    if (maxDiff > 0.1) return 12;
    return 13;
  };

  return (
    <div className="w-full h-full relative">
      <MapContainer
        center={getMapCenter()}
        zoom={getInitialZoom()}
        style={{ height: '100%', width: '100%' }}
        className="rounded-lg"
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          lang="en"
        />
        
        {shops.map((shop) => {
          if (!shop.geometry?.coordinates) return null;
          
          const [lng, lat] = shop.geometry.coordinates;
          const radiusInMeters = shop.radius * 1000; // Convert km to meters
          
          return (
            <React.Fragment key={shop._id}>
              {/* Delivery radius circle */}
              <Circle
                center={[lat, lng]}
                radius={radiusInMeters}
                pathOptions={{
                  color: '#2563eb', // Blue color
                  fillColor: '#3b82f6',
                  fillOpacity: 0.1,
                  weight: 1
                }}
              />
              
              {/* Shop marker */}
              <Marker position={[lat, lng]}>
                <Popup>
                  <div className="text-sm">
                    <h3 className="font-bold text-base mb-1">{shop.shopName}</h3>
                    <p className="mb-1">{shop.formattedAddress}</p>
                    <p className="text-blue-600">
                      Delivery Radius: {shop.radius} km
                    </p>
                  </div>
                </Popup>
              </Marker>
            </React.Fragment>
          );
        })}
      </MapContainer>
    </div>
  );
};

export default ShopLocationsMap;